"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformBillingInformationToMangopayUserOptions = transformBillingInformationToMangopayUserOptions;
const legacy_config_1 = require("@daytrip/legacy-config");
const legacy_enums_1 = require("@daytrip/legacy-enums");
const legacy_models_1 = require("@daytrip/legacy-models");
const utils_1 = require("@daytrip/utils");
const transformDateToMangopayTimestamp_1 = require("./transformDateToMangopayTimestamp");
const transformDomainCountryToMangopayCountry_1 = require("./transformDomainCountryToMangopayCountry");
const transformToMangopayAddress_1 = require("./transformToMangopayAddress");
const transformToMangopayName_1 = require("./transformToMangopayName");
function transformBillingInformationToMangopayUserOptions(user, billingInformation, countries, create) {
    const { nationalityCountry, residenceCountry, representativeAddressCountry, headquartersAddressCountry } = countries;
    const mangopayInformation = user.mangopayInformation.find((mi) => mi.billingInformationId === billingInformation._id);
    const parsedPhoneNumber = (0, utils_1.parsePhoneNumber)(user.phoneNumber);
    let options;
    if (billingInformation.type === legacy_enums_1.BillingInformationType.Natural) {
        options = {
            Id: mangopayInformation?.mangopayId ?? legacy_config_1.MANGOPAY_DEFAULT_DUMMY_ID, // TODO
            Email: billingInformation.email,
            Name: (0, transformToMangopayName_1.transformToMangopayName)(billingInformation),
            Address: (0, transformToMangopayAddress_1.transformToMangopayAddress)(billingInformation.address, residenceCountry),
            FirstName: billingInformation.firstName,
            LastName: billingInformation.lastName,
            Birthday: (0, transformDateToMangopayTimestamp_1.transformDateToMangopayTimestamp)(billingInformation.birthdayAt),
            Nationality: (0, transformDomainCountryToMangopayCountry_1.transformDomainCountryToMangopayCountry)(nationalityCountry.isoCode),
            CountryOfResidence: (0, transformDomainCountryToMangopayCountry_1.transformDomainCountryToMangopayCountry)(residenceCountry.isoCode),
            Occupation: billingInformation.occupation,
            IncomeRange: billingInformation.annualIncomeRangeInEuro,
            PhoneNumber: parsedPhoneNumber?.number,
            PhoneNumberCountry: (0, transformDomainCountryToMangopayCountry_1.transformDomainCountryToMangopayCountry)(parsedPhoneNumber?.country),
            NaturalSca: true,
            TermsAndConditionsAccepted: true,
        };
    }
    else if (billingInformation.type === legacy_enums_1.BillingInformationType.Legal ||
        billingInformation.type === legacy_enums_1.BillingInformationType.Soletrader) {
        options = {
            LegalPersonType: billingInformation.type === legacy_enums_1.BillingInformationType.Legal
                ? legacy_models_1.MangopayLegalPersonType.Business
                : legacy_models_1.MangopayLegalPersonType.Soletrader,
            Id: mangopayInformation?.mangopayId ?? legacy_config_1.MANGOPAY_DEFAULT_DUMMY_ID,
            Name: (0, transformToMangopayName_1.transformToMangopayName)(billingInformation),
            LegalRepresentative: {
                FirstName: billingInformation.firstName,
                LastName: billingInformation.lastName,
                Email: billingInformation.email || "",
                Birthday: (0, transformDateToMangopayTimestamp_1.transformDateToMangopayTimestamp)(billingInformation.birthdayAt),
                Nationality: (0, transformDomainCountryToMangopayCountry_1.transformDomainCountryToMangopayCountry)(nationalityCountry.isoCode),
                CountryOfResidence: (0, transformDomainCountryToMangopayCountry_1.transformDomainCountryToMangopayCountry)(residenceCountry.isoCode),
                PhoneNumber: parsedPhoneNumber?.number,
                PhoneNumberCountry: (0, transformDomainCountryToMangopayCountry_1.transformDomainCountryToMangopayCountry)(parsedPhoneNumber?.country),
            },
            Email: billingInformation.email || "",
            LegalRepresentativeAddress: (0, transformToMangopayAddress_1.transformToMangopayAddress)(billingInformation.address, representativeAddressCountry),
            HeadquartersAddress: (0, transformToMangopayAddress_1.transformToMangopayAddress)(billingInformation.headquartersAddress, headquartersAddressCountry),
            CompanyNumber: billingInformation.companyIdNumber,
            LegalSca: true,
            TermsAndConditionsAccepted: true,
        };
    }
    else {
        throw Error(legacy_enums_1.RejectionType.NotFound);
    }
    if (create === false) {
        return options;
    }
    if (billingInformation.type === legacy_enums_1.BillingInformationType.Natural) {
        return {
            ...options,
            PersonType: legacy_enums_1.MangopayPersonType.Natural,
            UserCategory: legacy_models_1.MangopayUserCategory.PAYER,
        };
    }
    return {
        ...options,
        PersonType: legacy_enums_1.MangopayPersonType.Legal,
        UserCategory: legacy_models_1.MangopayUserCategory.OWNER,
    };
}
//# sourceMappingURL=transformBillingInformationToMangopayUserOptions.js.map